import {Alert} from '@mui/material'
import {useTheme} from '@mui/material/styles'

export default function Footer() {
  const theme = useTheme()

  return (
    <div style={{
      display: 'block',
      height: '25px',
      position: 'fixed',
      bottom: '55px',
      left: '0px',
      backgroundColor: theme.palette.footerBackGround.main,
      width: '100%',
      textAlign:'center'
    }}>
      Dati meteo: <a style={{textDecoration:'none'}} href='https://openweathermap.org/' rel='noreferrer' target='_blanck'>Open weather</a> | My-meteo | Free to use
      
    </div>
  )
}